import React, { useState } from 'react';
import { Button, Tooltip, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { ResultsData, ResultsRow } from 'components/styled-components';
import EditDrawer from 'containers/Manage-Admin/departments/editDrawer';
import { DialogWrapper } from 'components/DialogWrapper';
import { archiveDepartment } from 'api/utils';
import { AppToaster } from 'components/AppToaster';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import styled from 'styled-components';
import { shouldBold } from 'utils/functions';

const getArchiveData = isActive => {
  if (isActive) {
    return {
      label: 'Archive',
      title: 'Archive Department',
      body:
        'Are you sure you want to archive this department? In progress and previously completed assessments will still reference this department.',
      icon: IconNames.PROJECTS,
      success: false,
    };
  } else {
    return {
      label: 'Activate',
      title: 'Activate Department',
      body: 'Are you sure you want to activate this department?',
      icon: IconNames.TICK_CIRCLE,
      success: true,
    };
  }
};

const DepartmentsTable = ({ department, fetch, appUser, searchQuery }) => {
  const [isOpen, toggleOpen] = useState(false);
  const [shouldArchive, toggleArchive] = useState(false);
  const [fromDrawer, setFromDrawer] = useState(false);

  const isActive = department.statusName === 'Active';
  const META_DATA = getArchiveData(isActive);

  const handleCloseDialog = () => {
    if (fromDrawer) {
      toggleArchive(false);
      setFromDrawer(false);
      toggleOpen(true);
    } else {
      toggleArchive(false);
    }
  };

  const toggleArchiveFromDrawer = () => {
    toggleOpen(false);
    setFromDrawer(true);
    toggleArchive(true);
  };

  const handleArchiveDepartment = () => {
    const departmentStatus = isActive ? 'Inactive' : 'Active';
    archiveDepartment(department.departmentID, departmentStatus)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        fetch();
        toggleArchive(false);
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
        toggleArchive(false);
      });
  };
  return (
    <ResultsRow cursor="default">
      <TableDataWithHeaders>
        {shouldBold(department.departmentName, searchQuery)}
      </TableDataWithHeaders>
      <TableDataWithHeaders>{department.description}</TableDataWithHeaders>
      <TableDataWithHeaders>{department.statusName}</TableDataWithHeaders>
      <TableDataWithHeaders>
        {hasPermission(appUser.permissions, permissions.MODIFY_DEPARTMENTS) && (
          <Tooltip content="Edit">
            <Button icon={IconNames.EDIT} minimal={true} onClick={toggleOpen} />
          </Tooltip>
        )}
        <Tooltip content={META_DATA.label}>
          <Button
            icon={META_DATA.icon}
            minimal={true}
            style={{ marginLeft: '0.5rem' }}
            onClick={toggleArchive}
          />
        </Tooltip>
      </TableDataWithHeaders>
      <EditDrawer
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        department={department}
        fetch={fetch}
        handleArchiveDepartment={handleArchiveDepartment}
        toggleArchiveFromDrawer={toggleArchiveFromDrawer}
        metaData={META_DATA}
      />
      <DialogWrapper
        isOpen={shouldArchive}
        onClose={handleCloseDialog}
        title={META_DATA.title}
        body={META_DATA.body}
        confirm="Confirm"
        action={handleArchiveDepartment}
      />
    </ResultsRow>
  );
};

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
  */
    &:nth-of-type(1):before {
      content: 'Department Name';
    }
    &:nth-of-type(2):before {
      content: 'Department Description';
    }
    &:nth-of-type(3):before {
      content: 'Department Status';
    }
    &:nth-of-type(4):before {
      content: 'Actions';
    }
  }
`;

export default DepartmentsTable;
